/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_List_Aria_LabelInputs */

const en_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker list`)
};

const fr_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des locuteurs`)
};

const de_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecherliste`)
};

const it_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco degli oratori`)
};

const ru_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список докладчиков`)
};

const es_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de oradores`)
};

const zh_cn2_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者名单`)
};

const ja_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`講演者リスト`)
};

const hi_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं की सूची`)
};

const pt_pt2_speaker_manager_list_aria_label = /** @type {(inputs: Speaker_Manager_List_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de oradores`)
};

/**
* | output |
* | --- |
* | "Speaker list" |
*
* @param {Speaker_Manager_List_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_list_aria_label = /** @type {((inputs?: Speaker_Manager_List_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_List_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_list_aria_label(inputs)
	if (locale === "de") return de_speaker_manager_list_aria_label(inputs)
	if (locale === "it") return it_speaker_manager_list_aria_label(inputs)
	if (locale === "ru") return ru_speaker_manager_list_aria_label(inputs)
	if (locale === "es") return es_speaker_manager_list_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_list_aria_label(inputs)
	if (locale === "ja") return ja_speaker_manager_list_aria_label(inputs)
	if (locale === "hi") return hi_speaker_manager_list_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_list_aria_label(inputs)
	return en_speaker_manager_list_aria_label(inputs)
});